// Spanish for the SOS Field app: clock. Keys are the English text exactly as written in the code.
export default {
  // utils/fieldClock.ts
  'Clocked in': 'Entrada',
  'Started break': 'Inicio de descanso',
  'Ended break': 'Fin de descanso',
  'Clocked out': 'Salida',

  // components/field/TimeClock.vue
  'Loading clock': 'Cargando reloj',
  'Off shift': 'Fuera de turno',
  'On break': 'En descanso',
  'On shift': 'En turno',
  'Clock in': 'Marcar entrada',
  'Clock out': 'Marcar salida',
  'Start break': 'Iniciar descanso',
  'End break': 'Terminar descanso',
  'Offline. Pending punches sync when you reopen the clock with a connection.':
    'Sin conexión. Las marcas pendientes se envían cuando abras el reloj con conexión.',
  'Connect once to load your clock.': 'Conéctate una vez para cargar tu reloj.',
  'Device storage is unavailable. Open the clock in a browser with storage enabled.':
    'Este teléfono no deja guardar datos. Abre el reloj en un navegador que sí permita guardar.',
  'Your office requires GPS at clock-in.':
    'Tu oficina pide el GPS al marcar entrada.',
  'Allow location or uncheck shift GPS to clock in without it.':
    'Permite la ubicación o quita la marca del GPS para marcar entrada sin él.',
  'Could not save this punch on this device.':
    'No se pudo guardar esta marca en este teléfono.',
  'Remove the unsent “{action}” from {time}? Tell the office if your attendance needs a correction.':
    '¿Borrar la marca “{action}” sin enviar del {time}? Avisa a la oficina si hay que corregir tu asistencia.',
  'Unable to load the saved clock on this phone.':
    'No se pudo cargar el reloj guardado en este teléfono.',
  'Time clock': 'Reloj',
  'Shift started {time}': 'Turno empezó: {time}',
  'Record the start and end of your shift here.':
    'Marca aquí el inicio y el fin de tu turno.',
  'worked this shift': 'de trabajo en este turno',
  'Share my GPS during this shift': 'Compartir mi GPS en este turno',
  'GPS is required for your clock-in.': 'Necesitas el GPS para marcar entrada.',
  'Your office can see your route while you work. GPS stops on breaks and at clock-out.':
    'Tu oficina puede ver tu ruta mientras trabajas. El GPS se apaga en los descansos y al marcar salida.',
  'Allow location access for tracking while the screen is locked.':
    'Permite el acceso a tu ubicación para seguir tu ruta con la pantalla bloqueada.',
  'Keep this page visible for GPS in a browser. Screen-lock tracking requires the SOS Field mobile app.':
    'En el navegador, deja esta página abierta para usar el GPS. Para seguir con la pantalla bloqueada necesitas la app SOS Field.',
  'Install SOS Field for Android': 'Instalar SOS Field en Android',
  'Shift GPS paused for your break.': 'GPS del turno en pausa por tu descanso.',
  'GPS enabled for this shift on the phone used to clock in.':
    'GPS activado en este turno, en el teléfono con el que marcaste entrada.',
  '{count} pending on this phone.': '{count} pendientes en este teléfono.',
  'Open this clock while online to send.':
    'Abre este reloj con conexión para enviarlas.',
  'Retry sync': 'Volver a enviar',
  'Unsent: {action} · {time}': 'Sin enviar: {action} · {time}',
  'Remove this unsent punch': 'Borrar esta marca sin enviar',
  'Recent punches': 'Marcas recientes',
  'Your confirmed punches will appear here.':
    'Aquí vas a ver tus marcas confirmadas.',

  // components/field/Timesheet.vue
  'Previous week': 'Semana anterior',
  'Next week': 'Semana siguiente',
  'Week of {date}': 'Semana del {date}',
  'Worked this week': 'Trabajado esta semana',
  '{time} on breaks': '{time} en descansos',
  'Shift still open': 'Turno todavía abierto',
  'Updated {time}': 'Actualizado {time}',
  'Confirmed punches only. Open Home to sync any punches waiting on your phone. Times shown in {zone}.':
    'Solo marcas confirmadas. Abre Inicio para enviar las marcas que esperan en tu teléfono. Horas en {zone}.',
  'Loading your hours…': 'Cargando tus horas…',
  Retry: 'Reintentar',
  'Daily hours': 'Horas por día',
  'Shift continued from the previous day.':
    'El turno siguió desde el día anterior.',
  'No punches recorded.': 'No hay marcas.',

  // pages/field/timesheet.vue
  'My work': 'Mi trabajo',
  Clocks: 'Reloj',
} as Record<string, string>
